import {
  currentDirection,
  directionOf,
  getCurrentLocaleCode,
  setLocaleCode,
  updateLocaleCode,
} from 'core/localization'
import {getLocalConfig} from 'core/localization/config'
import routerEvents from 'core/react-router/events'
import {public_url} from './global'



const defaultLocaleCode = getLocalConfig('defaultLocaleCode')

// Set default locale code
setLocaleCode(defaultLocaleCode)

export function detectDirection() {
  routerEvents.onLocalCodeChange((newLocaleCode) => {
    if (getCurrentLocaleCode() === newLocaleCode) return

    updateLocaleCode(newLocaleCode)

    setLocaleCode(newLocaleCode)
  })
}
